import React, { useState } from "react";
import { Select, SelectItem } from "./components/select.js";
import { Input } from "./components/input.js";
import { Button } from "./components/button.tsx";

const topics = {
  Health: ["Cardiology", "Dermatology", "Pediatrics"],
  Wellness: ["Nutrition", "Exercise", "Mental Health"],
  Insurance: ["Coverage", "Claims", "Billing"],
};

function ForumPage() {
  const [selectedTopic, setSelectedTopic] = useState("");
  const [selectedSubtopic, setSelectedSubtopic] = useState("");
  const [question, setQuestion] = useState("");
  const [forumPosts, setForumPosts] = useState([
    {
      topic: "Health",
      subtopic: "Cardiology",
      question: "What are common signs of a heart attack?",
      upvotes: 3,
      replies: [
        {
          author: "Dr. Jane",
          text: "Chest pain and shortness of breath are common symptoms.",
        },
      ],
    },
    {
      topic: "Wellness",
      subtopic: "Mental Health",
      question: "How do I manage daily anxiety?",
      upvotes: 5,
      replies: [
        {
          author: "Dr. Doe",
          text: "Deep breathing and regular exercise help a lot.",
        },
      ],
    },
    {
      topic: "Insurance",
      subtopic: "Coverage",
      question: "What does my plan cover for surgery?",
      upvotes: 2,
      replies: [
        {
          author: "Dr. Sarah",
          text: "Check with your provider but most plans cover major surgeries after deductible.",
        },
      ],
    },
  ]);
  const [searchTerm, setSearchTerm] = useState("");

  const handlePost = () => {
    if (selectedTopic && selectedSubtopic && question) {
      const newPost = {
        topic: selectedTopic,
        subtopic: selectedSubtopic,
        question,
        upvotes: 0,
        replies: [],
      };
      setForumPosts([newPost, ...forumPosts]);
      setQuestion("");
    }
  };

  const handleUpvote = (index) => {
    const updatedPosts = [...forumPosts];
    updatedPosts[index].upvotes++;
    setForumPosts(updatedPosts);
  };

  const handleReply = (index, replyText) => {
    if (!replyText) return;
    const updatedPosts = [...forumPosts];
    updatedPosts[index].replies.push({
      author: "Dr. Provider",
      text: replyText,
    });
    setForumPosts(updatedPosts);
  };

  const filteredPosts = forumPosts.filter(
    (post) =>
      post.question.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.topic.toLowerCase().includes(searchTerm.toLowerCase()) ||
      post.subtopic.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  return (
    <div className="max-w-4xl mx-auto p-6 space-y-6">
      <h1 className="text-2xl font-bold">Forum</h1>

      <Input
        placeholder="Search questions, topics, or subtopics..."
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <Select
          value={selectedTopic}
          onValueChange={(val) => {
            setSelectedTopic(val);
            setSelectedSubtopic("");
          }}
        >
          <SelectItem value="">Select Topic</SelectItem>
          {Object.keys(topics).map((topic) => (
            <SelectItem key={topic} value={topic}>
              {topic}
            </SelectItem>
          ))}
        </Select>

        <Select value={selectedSubtopic} onValueChange={setSelectedSubtopic}>
          <SelectItem value="">Select Subtopic</SelectItem>
          {(topics[selectedTopic] || []).map((sub) => (
            <SelectItem key={sub} value={sub}>
              {sub}
            </SelectItem>
          ))}
        </Select>
      </div>

      <textarea
        className="w-full border rounded p-2 mt-2"
        rows={3}
        placeholder="Write your question here..."
        value={question}
        onChange={(e) => setQuestion(e.target.value)}
      ></textarea>

      <Button onClick={handlePost}>Post Question</Button>

      <div className="space-y-4 pt-6">
        {filteredPosts.map((post, index) => (
          <div key={index} className="border p-4 rounded shadow">
            <div className="flex justify-between items-center">
              <div>
                <p className="text-lg font-semibold">{post.question}</p>
                <p className="text-sm text-gray-600">
                  Topic: {post.topic} / {post.subtopic}
                </p>
              </div>
              <Button
                onClick={() => handleUpvote(index)}
                className="text-sm bg-yellow-400 text-black px-2 py-1"
              >
                ⬆ {post.upvotes}
              </Button>
            </div>

            <div className="mt-2 pl-4 border-l">
              {post.replies.map((reply, idx) => (
                <p key={idx} className="text-sm text-gray-700">
                  <strong>{reply.author}:</strong> {reply.text}
                </p>
              ))}
              <Input
                className="mt-2"
                placeholder="Write a reply..."
                onKeyDown={(e) => {
                  if (e.key === "Enter") {
                    handleReply(index, e.target.value);
                    e.target.value = "";
                  }
                }}
              />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ForumPage;
